import { DOWNLOADS_LIST_QUERY_KEY } from "@entities/downloads/lib/constant";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { AccountingService } from "../services/Accounting.service";

export function useDownloadAccounting() {
  const {
    mutate: downloadAccounting,
    isLoading: isDownloadingAccountingLoading,
    isSuccess: isDownloadingAccountingSuccess,
  } = useMutation({
    mutationFn: (data: {
      accountingDate: {
        from: string;
        to: string;
      };
    }) =>
      AccountingService.downloadAccounting(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: { skipInvalidation: false },
    onSuccess: (c) => {
      setTimeout(() => {
        c.invalidateQueries({ queryKey: DOWNLOADS_LIST_QUERY_KEY });
      }, 1000);
    },
  });

  return {
    downloadAccounting,
    isDownloadingAccountingLoading,
    isDownloadingAccountingSuccess,
  };
}
